// extracted by mini-css-extract-plugin
module.exports = {"root":"Content_root__pDc9L","rootBackgroundGradient":"Content_rootBackgroundGradient__bfsV_"};